import api from "@/lib/api";
import { startRecording, pickMime } from "@/components/meeting/recorder";

const FLUSH_AT = 2 * 1024 * 1024;

/* Records the meeting and uploads it to the cloud in ~2MB pieces while it runs. */
export async function startCloudRecording(confId, getVideos, getStreams, logoUrl) {
  const mime = pickMime();
  const { data: rec } = await api.post("/api/recordings", { conf_id: confId, mime: mime || "video/webm" });
  let buf = [], size = 0, seq = 0, failed = 0, queue = Promise.resolve();
  const startedAt = Date.now();
  const flush = () => {
    if (!size) return;
    const blob = new Blob(buf), n = seq++;
    buf = []; size = 0;
    const put = () => api.post(`/api/recordings/${rec.id}/chunk`, blob, { params: { seq: n }, headers: { "Content-Type": "application/octet-stream" } });
    queue = queue.then(() => put().catch(() => put())).catch(() => { failed += 1; });
  };
  const stopRec = startRecording(getVideos, getStreams, logoUrl, (b) => { buf.push(b); size += b.size; if (size >= FLUSH_AT) flush(); }, mime);
  return async () => {
    await stopRec();
    flush();
    await queue;
    await api.post(`/api/recordings/${rec.id}/finish`, { duration_secs: Math.round((Date.now() - startedAt) / 1000) }).catch(() => {});
    return { id: rec.id, failed };
  };
}
